import { render, staticRenderFns } from "./GdkvDetail.vue?vue&type=template&id=5b05875a&scoped=true"
import script from "./GdkvDetail.vue?vue&type=script&lang=js"
export * from "./GdkvDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05875a",
  null
  
)

export default component.exports